import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageSquare, MapPin } from 'lucide-react';
export function CTASection() {
  return <section id="contact" className="py-24 bg-forest-900 relative overflow-hidden" data-id="element-30">
      {/* Decorative background circles */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-forest-700/30 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-31" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-forest-500/20 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" data-id="element-32" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-34">
          <span className="inline-block py-1 px-4 rounded-full bg-white/10 text-cream-100 text-sm font-bold tracking-widest uppercase mb-8 border border-white/20" data-id="element-35">
            Ready to get started?
          </span>

          <h2 className="text-4xl md:text-6xl font-heading font-bold text-white mb-6" data-id="element-36">
            One Call. Honest Quote. <br className="hidden sm:block" data-id="element-37" />
            <span className="text-cream-200 italic" data-id="element-38">Done Right.</span>
          </h2>

          <p className="text-xl text-cream-100/90 mb-12 max-w-2xl mx-auto" data-id="element-39">
            Tell us what your property needs. We'll give you a clear,
            no-surprise estimate. Free estimate — no commitment required.
          </p>

          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl max-w-3xl mx-auto" data-id="element-40">
            <div className="mb-8" data-id="element-41">
              <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-42">
                Call or Text Pancho Directly
              </p>
              <a href="tel:8153540484" className="text-4xl md:text-6xl font-bold text-forest-900 hover:text-forest-700 transition-colors" data-id="element-43">
                (815) 354-0484
              </a>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8" data-id="element-44">
              <a href="tel:8153540484" className="flex flex-col items-center justify-center gap-2 bg-forest-700 hover:bg-forest-900 text-white p-4 rounded-xl transition-colors group" data-id="element-45">
                <div className="flex items-center gap-2 text-lg font-bold" data-id="element-46">
                  <Phone size={20} className="group-hover:animate-bounce" data-id="element-47" />
                  Call Now
                </div>
                <span className="text-sm text-cream-100/80" data-id="element-48">
                  Mon–Sat · 7am–7pm
                </span>
              </a>

              <a href="sms:8153540484" className="flex flex-col items-center justify-center gap-2 bg-earth-900 hover:bg-earth-700 text-white p-4 rounded-xl transition-colors group" data-id="element-49">
                <div className="flex items-center gap-2 text-lg font-bold" data-id="element-50">
                  <MessageSquare size={20} className="group-hover:animate-pulse" data-id="element-51" />
                  Text Us
                </div>
                <span className="text-sm text-cream-100/80" data-id="element-52">
                  We respond fast
                </span>
              </a>
            </div>

            <div className="flex items-center justify-center gap-2 text-sm font-medium text-gray-600" data-id="element-53">
              <MapPin size={16} className="text-forest-700" data-id="element-54" />
              Serving IL & WI
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}